import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import DefaultMessageContent
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/DefaultMessageContent';
import TaskMessageContent
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/TaskMessageContent';
import ScenarioMessageContent
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/ScenarioMessageContent';
import MeetingCommunicationMessageContent
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/MeetingCommunicationMessageContent';
import MeetingEventMessageContent
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/MeetingEventMessageContent';
import PlanMessageContent
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/PlanMessageContent';
import { noop } from 'Helpers/PropTypes';
import EmailMessageContent
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/EmailMessageContent';
import MessageWithResponseButtonsContent
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/MessageWithResponseButtonsContent';
import MemberDataCaptureMessageContent
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/MemberDataCaptureMessageContent';
import EstatePlanMessageContent
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/EstatePlanMessageContent';
import TaxDiagnosticContent from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/TaxDiagnosticMessageContent/TaxDiagnosticMessageContent';
import ManagedAccountDisclaimersContent from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/ManagedAccountDisclaimersMessageContent/ManagedAccountDisclaimersMessageContent';
import MessageWithPageLinkContent
  from 'Organisms/MessageList/MessageListItem/MessageContent/Content/MessageWithPageLinkContent';
import MessageWithRoutedThreadContentContainer
  from 'Organisms/MessageList/MessageListItem/MessageContent/Content/MessageWithRoutedThreadContent';

// Message Content Types
export const TASK = 'task';
export const EMAIL = 'email';
export const MEETING_COMMUNICATION = 'meeting-communication';
export const SCENARIO = 'scenario';
export const MEETING_EVENT = 'meeting-event';
export const PLAN = 'plan';
export const MEMBER_DATA_CAPTURE = 'member-data-capture';
export const ESTATE_PLANNING = 'estate-planning';
export const TAX_DIAGNOSTIC = 'tax-diagnostic';
export const MANAGED_ACCOUNT_DISCLAIMERS = 'managed-account-disclaimers';
export const SYSTEM_NOT_VISIBLE_TO_MEMBER = 'system-not-visible-to-member';
export const SYSTEM_NEW_ROUTED_THREAD = 'system-new-routed-thread';
export const SYSTEM_START_OF_ROUTED_THREAD_MESSAGE_TYPE = 'system-start-of-routed-thread';

// Message Content Component Map
const MESSAGE_CONTENT_MAP = {
  [TASK]: TaskMessageContent,
  [MEETING_COMMUNICATION]: MeetingCommunicationMessageContent,
  [MEETING_EVENT]: MeetingEventMessageContent,
  [SCENARIO]: ScenarioMessageContent,
  [PLAN]: PlanMessageContent,
  [EMAIL]: EmailMessageContent,
  [MEMBER_DATA_CAPTURE]: MemberDataCaptureMessageContent,
  [ESTATE_PLANNING]: EstatePlanMessageContent,
  [TAX_DIAGNOSTIC]: TaxDiagnosticContent,
  [MANAGED_ACCOUNT_DISCLAIMERS]: ManagedAccountDisclaimersContent,
  [SYSTEM_NEW_ROUTED_THREAD]: MessageWithRoutedThreadContentContainer,
  [SYSTEM_START_OF_ROUTED_THREAD_MESSAGE_TYPE]: MessageWithRoutedThreadContentContainer,
};

const MessageContent = ({
  messageResource,
  onLoadComplete,
}) => {
  if (!messageResource) return null;

  // Pick the correct content, If none are found select the default
  let MessageContentComponent = MESSAGE_CONTENT_MAP[messageResource.attr('messageType')];
  if (messageResource.relationship(fr.relationships.innerMessageResponse.name)) {
    MessageContentComponent = MessageWithResponseButtonsContent;
  }
  if (messageResource.relationship(fr.relationships.specificPageLink.name)) {
    MessageContentComponent = MessageWithPageLinkContent;
  }

  if (MessageContentComponent) {
    return <MessageContentComponent messageResource={messageResource} onLoadComplete={() => onLoadComplete()} />;
  }

  return <DefaultMessageContent messageResource={messageResource} onLoadComplete={() => onLoadComplete()} />;
};

MessageContent.defaultProps = {
  onLoadComplete: noop,
};

MessageContent.propTypes = {
  messageResource: PropTypes.instanceOf(fr.Resource).isRequired,
  onLoadComplete: PropTypes.func,
};

export default MessageContent;
